var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseOtherPossibleDeathReasons',{key:_vm.versionkeyreload,attrs:{"OtherPossibleDeathReasons":_vm.payload,"entrycode":_vm.entrycode,"passed":true}})}
var staticRenderFns = []

export { render, staticRenderFns }